import { Subscription } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { PortalSettings, SessionService, User } from '@edl-development/edl-common';
import { PermissionTypes } from 'src/app/model/enum/permission-types.enum';

export const ADMINISTRATION_STATES = [
    'authenticated.administration',
    'authenticated.buildings',
    'authenticated.custom-form-builder',
    'authenticated.assignments',
    'authenticated.preset-management',
];

@Component({
    selector: 'edl-authenticated-navigation',
    templateUrl: './edl-authenticated-navigation.component.html',
    styleUrls: ['./edl-authenticated-navigation.component.scss']
})

export class EdlAuthenticatedNavigationComponent implements OnInit{
    PermissionTypes = PermissionTypes;

    ViewMyObservations:boolean = false;
    user?: User | null;
    viewCurrentUser:Boolean = false;
    _navigationToggle?: Subscription;
    _activeUserSub?: Subscription;
    _viewMyObservationsSub?: Subscription;
    _viewMyObs?: Subscription;
    minMenu: boolean = false;
    viewingCurrentUser: boolean = false ;

    supervisorManagementCollapsed: boolean = true;
    myComplianceItemsCollapsed: boolean = true;
    questionnairesCollapsed: boolean = true;
    userManagementCollapsed: boolean = true;
    administrationCollapsed: boolean = true;
    reportingCollapsed: boolean = true;
    permissionsCollapsed: boolean = true;
    portalSettings?:PortalSettings;

    ADMINISTRATION_STATES = ADMINISTRATION_STATES;

    constructor(
        public stateService: StateService,
        public sessionService: SessionService
    ) {}

    ngOnInit() {

        this.ViewMyObservations = this.stateService.includes('authenticated.user-summary');

        this.portalSettings = this.sessionService.PortalSettings;
        this.user = this.sessionService.user;


        this.supervisorManagementCollapsed = !this.stateService.includes('authenticated.supervision-management');
        this.myComplianceItemsCollapsed = !this.stateService.includes('authenticated.my-compliance-items');
        this.userManagementCollapsed = !this.stateService.includes('authenticated.users');
        this.administrationCollapsed = ADMINISTRATION_STATES.every(state => !this.stateService.includes(state));
        this.permissionsCollapsed = !this.stateService.includes('authenticated.permissions');
        this.reportingCollapsed = !this.stateService.includes('authenticated.reporting');

        this._navigationToggle = this.sessionService.navigationToggle.subscribe((value: boolean) => {
          this.minMenu = value;
        });

        this._activeUserSub = this.sessionService.activeUser.subscribe((user: User) => {
          this.user = user;
        });


        this._viewMyObservationsSub = this.sessionService.viewingCurrentUser.subscribe((value: boolean) => {
          this.viewingCurrentUser = value;
        });


    }

    isActive(states: string[]) {
        return states.some(state => this.stateService.includes(state));
    }


    isInActiveState(loc:string){
        return this.stateService.includes(loc);
    }

    toggleMenu() {
        this.sessionService.toggleMenu();
    }
}
